<script>
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import { baseProps } from '@/libs/utils/forms/baseProps.js'

export default {
  components: {
    Label
  },
  props: {
    ...baseProps,
    value: {
      type: Array,
      default: null
    },
    maxlengthButtonDisabled: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data () {
    return {
      val: ''
    }
  },
  computed: {
    errorsInput () {
      if (this.observer) {
        return this.observer.errors[ this.nomeAba + '/' + this.label ]
      }
      return []
    },
    validationValues () {
      return { multiTexts: this.value }
    }
  },
  methods: {
    add (val) {
      this.value.push(val)
      this.val = ''
    },
    remove (index) {
      this.value.splice(index, 1)
    },
    updateValue (val) {
      this.$emit('input', val)
    }
  }
}
</script>

<template>
  <div>
    <validation-provider :rules="obrigatorio && !value.length ? `min_items:1,${label}` : ''" :name="nomeAba + '/' + label" v-slot="{ errors }">
      <el-col :span="widthColumn" :class="marginLeft ? 'ml-forms' : ''">
        <Label :label="label" :obrigatorio="obrigatorio" :Indice="Indice" />
        <el-input
          v-if="vMask"
          v-mask="vMask"
          class="input"
          :name="label"
          :class="{'input erro' : errors.length}"
          v-model="val"
        >
          <template #append>
            <el-button
              class="style"
              icon="el-icon-plus"
              @click="add(val)"
              :disabled="val.length < maxlengthButtonDisabled"
            />
          </template>
        </el-input>

        <el-input
          v-else
          class="input"
          :name="label"
          :class="{'input erro' : errors.length}"
          v-model="val"
        >
          <template #append>
            <el-button
              class="style"
              icon="el-icon-plus"
              @click="add(val)"
              :disabled="val.length < maxlengthButtonDisabled"
            />
          </template>
        </el-input>

        <span v-if="errors.length" class="help erro"> {{ errors[0] }}</span>

        <div class="tag-app-input" style="margin-top: 4px;">
          <el-tag
            v-for="(val, index) in value"
            :key="index"
            closable
            type="info"
            size="medium"
            @close="remove(index)"
            style="margin-right: 4px;
            margin-bottom: 4px;"
          >
            {{ val }}
          </el-tag>
        </div>
      </el-col>
    </validation-provider>
  </div>
</template>

<style lang="scss" scoped>
@import '@/scss/_colors.scss';
@import '@/scss/_mixins.scss';
@import '@/scss/_typography.scss';
@import '@/scss/_utilities.scss';

.setFonts {
  [class^="el-"],
  [class*=" el-"] {
    @include set-rawline-regular;
  }
}
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Forms/InputMultiTexts/InputMultiTexts.vue